import { useMedplumContext } from '@medplum/react-hooks'
import type { SeenMedplumClient } from '@seen/core/client'

/**
 * This is a shortcut for useMedplumContext().medplum.
 * @returns The SeenMedplumClient instance.
 */
export const useMedplum = (): SeenMedplumClient => {
  const context = useMedplumContext()
  return context.medplum as SeenMedplumClient
}

export const useMedplumOptional = (): SeenMedplumClient | undefined => {
  const context = useMedplumContext()
  return context?.medplum as SeenMedplumClient | undefined
}
